import React from 'react';
import { ScreenWrapper } from '.';

export const OptionList = (props) => {
    return <ScreenWrapper {...props}></ScreenWrapper>;
};
